export enum CommonEventDetailId {
  HasLineups = 205,
  PeriodLength = 16,
  NumberOfPeriods = 17,
  ExtraPeriodLength = 50,
  NumberOfExtraPeriods = 51,
  TimerDirection = 124,
}
